// Состояние чата на главной: сообщения, поле ввода, разбор документа. Рисует их ChatPage.
import { createContext, type ReactNode } from "react";
import { Store } from "../store";

// Кнопки рядом с вариантами ответа гаснут вместе с ними, когда на вопрос ответили.
export const QuestionClosed = createContext(false);

export type Choice = { label: string; value: string };

// Вопрос с вариантами: после ответа все кнопки сообщения гаснут, выбранная подсвечивается.
export type QuestionView = {
  choices: Choice[];
  skip: string | null;
  extra: ReactNode[];
  closed: boolean;
  chosen?: string;
  choose: (value: string, label: string) => void;
};

export type Message =
  | { id: number; role: "user"; text: string }
  | { id: number; role: "bot"; parts: ReactNode[]; question?: QuestionView; footer?: ReactNode };

export const DEFAULT_PLACEHOLDER = "Опишите задачу или прикрепите документ…";
export const DEFAULT_HINT = "Enter ↵";

export type ComposerState = {
  placeholder: string;
  hint: string;
  flow: { hidden: boolean; title: string; cancel: string };
};

const EMPTY_COMPOSER: ComposerState = {
  placeholder: DEFAULT_PLACEHOLDER, hint: DEFAULT_HINT, flow: { hidden: true, title: "", cancel: "Прервать" },
};

export const messagesStore = new Store<Message[]>([]);
export const composerStore = new Store<ComposerState>(EMPTY_COMPOSER);
// busy — идёт разбор (кнопки отправки и скрепка недоступны); epoch — номер открытого разбора.
export const reviewStore = new Store({ busy: false, epoch: 0 });

// Чат закрыт переходом в другой раздел: следующий откроется с чистого листа.
export function resetChatState() {
  messagesStore.set([]);
  composerStore.set(EMPTY_COMPOSER);
  reviewStore.set({ busy: false, epoch: 0 });
}
